module.exports = __webpack_public_path__ + "img/parmejan.2ff7390f.png";